import React from 'react';
import { SocialIcon } from 'react-social-icons';

export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#2E073F', color: '#fff' }}>
      
      {/* Top Social Bar */}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px 40px',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        }}
      >
        <p style={{ margin: 0, fontSize: '16px', flex: '1 1 100%', textAlign: 'center', marginBottom: '10px' }}>
          Get connected with us on social networks:
        </p>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flex: '1 1 100%',
            gap: '12px',
          }}
        >
        <SocialIcon  href="https://www.instagram.com/aarogyamdental?igsh=MXI5cXZyZjhqM2dmOQ==" url="www.whatsapp.com" />
        <SocialIcon  href="https://www.instagram.com/aarogyamdental?igsh=MXI5cXZyZjhqM2dmOQ==" url="www.facebook.com" />
        <SocialIcon  href="https://www.instagram.com/aarogyamdental?igsh=MXI5cXZyZjhqM2dmOQ==" url="www.instagram.com" />
        </div>
      </div>

      {/* Contact Info Section */}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          padding: '40px',
          rowGap: '30px',
        }}
      >
        {/* Contact Numbers */}
        <div style={{ flex: '1', minWidth: '250px' }}>
          <h4 style={{ marginBottom: '12px' }}>Contact Us</h4>
          <p style={{ margin: '6px 0' }}>📞 +919032821700</p>
          <p style={{ margin: '6px 0' }}>
            📧{' '}
            <a
              href="mailto:aarogyamdental.adc@gmail.com.com"
              style={{ color: '#ccc', textDecoration: 'none' }}
            >
              aarogyamdental.adc@gmail.com
            </a>
          </p>
        </div>

        {/* Address */}
        <div style={{ flex: '1', minWidth: '250px' }}>
          <h4 style={{ marginBottom: '12px' }}>Clinic Address</h4>
          <p>🏥 Aarogyam Dental Care</p>
          <p>📍 First floor Plot, No: 320, Rd No 7, Kakatiya Hills, Guttala_Begumpet, Kavuri Hills, Madhapur, Hyderabad, Telangana 500081</p>
        </div>

        {/* Website Info */}
        <div style={{ flex: '1', minWidth: '250px' }}>
          <h4 style={{ marginBottom: '12px' }}>Website</h4>
          <a
            href="https://www.aarogyamdentalcare.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#ccc', textDecoration: 'none' }}
          >
           www.aarogyamdentalcare.com
          </a>
        </div>
      </div>

      {/* Footer Bottom */}
      <div
        style={{
          textAlign: 'center',
          backgroundColor: '#7A1CAC',
          padding: '16px',
          fontSize: '15px',
        }}
      >
        © 2025 Aarogyam Dental Care — All rights reserved.
      </div>
    </footer>
  );
}
